var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-text-center cover"},[_c('h1',[_vm._v("秀 Themes")]),_c('p',[_vm._v("디자인파일 및 코딩소스파일을 다운로드 받으세요.")])])}]

export { render, staticRenderFns }